import React from "react";

import { Card } from "@churchofjesuschrist/eden-card";
import { Image } from "@churchofjesuschrist/eden-image";
import {
  spacing16,
} from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import Modal from "../../generic/headerless-modal/headerless-modal";
import useManagedStrings from "../../utils/use-managed-strings";

const PaddedCard = styled(Card)`
  padding: ${spacing16};
  margin: ${spacing16};
`;

const stringGroups = [{
  name: "shared",
  keys: ["pwaInstall", "pwaInstallStep1", "pwaInstallStep2"]
}];
const defaultFunc = () => {};
const IosPwaModal = ({ active = false, onCancelClick = defaultFunc }) => {
  const { managedStrings } = useManagedStrings(stringGroups);
  return (
    <Modal active={active} onCloseGesture={onCancelClick}>
      <PaddedCard>
        <div>{managedStrings.pwaInstall}</div>
        <ol>
          <li>{managedStrings.pwaInstallStep1} <Image height="16" src="/iOS_Upload.svg"/></li>
          <li>{managedStrings.pwaInstallStep2} <Image height="16" src="/Add_To_Home.svg"/></li>
        </ol>
      </PaddedCard>
    </Modal>
  );
};

export default IosPwaModal;